import { type CollectionStoreSummary } from '@Src/types/collectionStoreTypes';
import { type DeliveryStoreSummary } from '@Src/types/deliveryStoreTypes';

export const getStoreOrderUrl = ({
  isCollection,
  storeSummary,
  deliveryLocationId,
  shouldForceCollectionStoreUrl,
}: {
  isCollection: boolean;
  storeSummary?: CollectionStoreSummary | DeliveryStoreSummary;
  deliveryLocationId?: number;
  shouldForceCollectionStoreUrl?: boolean;
}): string | undefined => {
  if (storeSummary?.VirtualRestaurantId && storeSummary?.PhysicalRestaurantId) {
    if (isCollection || shouldForceCollectionStoreUrl) {
      return `/order#/restaurant/${storeSummary.VirtualRestaurantId}/collection/${storeSummary.PhysicalRestaurantId}`;
    } else if (!isCollection && deliveryLocationId) {
      return `/order#/restaurant/${storeSummary.VirtualRestaurantId}/delivery/${deliveryLocationId}`;
    }
  }
  return undefined;
};

type NavigateToWebOrderType = {
  isCollection: boolean;
  storeSummary?: CollectionStoreSummary | DeliveryStoreSummary;
  deliveryLocationId?: number;
};

export const useNavigateToWebOrder = (): ((
  x: NavigateToWebOrderType,
) => void) => {
  const navigateToWebOrder = ({
    isCollection,
    storeSummary,
    deliveryLocationId,
  }: NavigateToWebOrderType): void => {
    const orderUrl = getStoreOrderUrl({
      isCollection,
      storeSummary,
      deliveryLocationId,
    });
    if (orderUrl) {
      let href = window.location.href;
      href = href.endsWith('/') ? href.slice(0, -1) : href;
      window.location.href = `${href}${orderUrl}`;
    }
  };
  return navigateToWebOrder;
};
